<template>
  <div class="chart">
    <div :id="report.id" :style="{width: report.width, height: report.height}"></div>
  </div>
</template>

<script>
// 引入基本模板
let echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/line')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
export default {
  name: "CurveChart",
  props: {
    report: {
      type: Array | Object,
      default() {
        return {};
      }
    },
    mode:{
      type:String | Number
    }
  },
  data() {
    return {}
  },
  mounted() {
    this.drawLine()
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById(this.report.id))
      // 绘制图表
      if (this.report.id == 'myChanneTransactionChart') {
        myChart.setOption({
          // title: {
          //   text: this.report.name, textStyle: {
          //     fontSize: 13,
          //   },
          // },
          grid:{
            x:60,
          },
          tooltip: {
            trigger: 'axis',
          },
          xAxis: {
            data: this.report.types
          },
          yAxis: {},
          series: this.report.data
        });
      } else {
        if(this.mode==0){
          myChart.setOption({
            // title: {
            //   text: this.report.name, textStyle: {
            //     fontSize: 13,
            //   },
            // },
            grid:{
              x:60,
            },
            tooltip: {
              trigger: 'axis',
              formatter: function (params) {
                let res = params[0].axisValueLabel;

                function getHtml(param) {
                  let str = '<div style="font-size: 12px; float: left;width:25%;display: flex;align-items: center"><span style="background: '
                      + param.color + '; width: 11px; height: 11px; border-radius: 11px;float: left; margin: 5px 3px;"></span>' +
                      '<span style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width:70%;display: inline-block">'+param.seriesName+'</span>：' + param.data + '&emsp;&emsp;</div>';
                  return str;
                }

                let flag = false;
                res += '<div style="clear: both">';
                for (let i = 0; i < params.length; i++) {
                  res += getHtml(params[i]);
                  if (params.length > 11 && i % 4 == 1) {
                    res += '</div><div style="clear: both">';
                  }
                  if (params.length <= 11) {
                    res += '</div><div style="clear: both">';
                  }
                }
                res += "</div>";
                return res;
              }
            },
            xAxis: {
              data: this.report.types
            },
            yAxis: {},
            series: this.report.data
          });
        }else {
          myChart.setOption({
            // title: {
            //   text: this.report.name, textStyle: {
            //     fontSize: 13,
            //   },
            // },
            grid:{
              x:60,
            },
            tooltip: {
              trigger: 'axis',
            },
            xAxis: {
              data: this.report.types
            },
            yAxis: {},
            series: this.report.data
          });
        }

      }

    }
  }
}
</script>

<style scoped lang="scss">
.chart {
  background: #ffffff;
  margin-right: 10px;
  padding-top: 10px;
  border-radius: 8px;
}
</style>